// extracted by mini-css-extract-plugin
module.exports =  {"person":"F_EGKpa0i6Ku7woloD8y","tag":"TsG9M_LJuuLWOLvXhxtN","cell":"_iirUuAT1eQhMnzesFjL","personCell":"JGDUcPRA0X2pJ8U7r0bj","companiesCell":"w1TezahjQS6OoqtD5g29"};